export var PluginType;
(function (PluginType) {
    PluginType[PluginType["FACEBOOK_PAGE"] = 1] = "FACEBOOK_PAGE";
    PluginType[PluginType["TWITTER_ACCOUNT"] = 2] = "TWITTER_ACCOUNT";
    PluginType[PluginType["INSTAGRAM_ACCOUNT"] = 3] = "INSTAGRAM_ACCOUNT";
})(PluginType || (PluginType = {}));
//# sourceMappingURL=plugin-type.enum.js.map